'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
});

var _slicedToArray = function () {
  function c(d, e) {
    var f = [],
        g = !0,
        h = !1,
        j = void 0;

    try {
      for (var l, k = d[Symbol.iterator](); !(g = (l = k.next()).done) && (f.push(l.value), !(e && f.length === e)); g = !0) {
        ;
      }
    } catch (m) {
      h = !0, j = m;
    } finally {
      try {
        !g && k['return'] && k['return']();
      } finally {
        if (h) throw j;
      }
    }

    return f;
  }

  return function (d, e) {
    if (Array.isArray(d)) return d;
    if (Symbol.iterator in Object(d)) return c(d, e);
    throw new TypeError('Invalid attempt to destructure non-iterable instance');
  };
}(),
    _typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (c) {
  return typeof c;
} : function (c) {
  return c && 'function' == typeof Symbol && c.constructor === Symbol && c !== Symbol.prototype ? 'symbol' : typeof c;
};

exports.default = wikiPage;

var _util = require('./util'),
    _infoboxParser = require('infobox-parser'),
    _infoboxParser2 = _interopRequireDefault(_infoboxParser),
    _coordinates = require('./coordinates');

function _interopRequireDefault(c) {
  return c && c.__esModule ? c : {
    default: c
  };
}

function _toConsumableArray(c) {
  if (Array.isArray(c)) {
    for (var d = 0, e = Array(c.length); d < c.length; d++) {
      e[d] = c[d];
    }

    return e;
  }

  return Array.from(c);
}

var get = function get(c, d) {
  for (var e = arguments.length, f = Array(2 < e ? e - 2 : 0), g = 2; g < e; g++) {
    f[g - 2] = arguments[g];
  }

  return void 0 === c || void 0 === d ? c : 'function' == typeof d ? get.apply(void 0, [d(c)].concat(f)) : get.apply(void 0, [c[d]].concat(f));
},
    firstValue = function firstValue(c) {
  return 'object' === ('undefined' == typeof c ? 'undefined' : _typeof(c)) ? c[Object.keys(c)[0]] : c[0];
},
    getFileName = function getFileName(c) {
  if (Array.isArray(c) && (c = c[0]), !!c) {
    if (-1 !== c.indexOf(':')) {
      var d = c.split(':'),
          e = _slicedToArray(d, 2),
          f = e[1];

      return f;
    }

    return c;
  }
};

function wikiPage(c, d) {
  function f() {
    return g().then(_util.parseContent);
  }

  function g() {
    return (0, _util.api)(d, {
      prop: 'extracts',
      explaintext: '',
      titles: x.title
    }).then(function (z) {
      return z.query.pages[x.pageid].extract;
    });
  }

  function j() {
    return (0, _util.api)(d, {
      generator: 'images',
      gimlimit: 'max',
      prop: 'imageinfo',
      iiprop: 'url',
      titles: x.title
    }).then(function (z) {
      return z.query ? Object.keys(z.query.pages).map(function (A) {
        return z.query.pages[A];
      }) : [];
    });
  }

  function q(z) {
    return (0, _util.api)(d, {
      prop: 'revisions',
      rvprop: 'content',
      rvsection: 0,
      titles: z || x.title
    }).then(function (A) {
      return get(A, 'query', 'pages', firstValue, 'revisions', 0, '*');
    });
  }

  function s(z) {
    return q().then(function (A) {
      var B = (0, _infoboxParser2.default)(A, d.parser).general;
      return 0 === Object.keys(B).length ? q('Template:Infobox ' + x.title.toLowerCase()).then(function (C) {
        return (0, _infoboxParser2.default)(C || '', d.parser).general;
      }) : B;
    }).then(function (A) {
      return z ? A.hasOwnProperty(z) ? A[z] : void 0 : A;
    });
  }

  var x = c;
  return {
    raw: x,
    html: function html() {
      return (0, _util.api)(d, {
        prop: 'revisions',
        rvprop: 'content',
        rvlimit: 1,
        rvparse: '',
        titles: x.title
      }).then(function (z) {
        return z.query.pages[x.pageid].revisions[0]['*'];
      });
    },
    rawContent: g,
    content: f,
    sections: f,
    summary: function summary() {
      return (0, _util.api)(d, {
        prop: 'extracts',
        explaintext: '',
        exintro: '',
        titles: x.title
      }).then(function (z) {
        return z.query.pages[x.pageid].extract;
      });
    },
    images: function images() {
      return j().then(function (z) {
        return z.map(function (A) {
          return A.imageinfo;
        }).reduce(function (A, B) {
          return [].concat(_toConsumableArray(A), _toConsumableArray(B));
        }, []).map(function (A) {
          return A.url;
        });
      });
    },
    references: function references() {
      return (0, _util.api)(d, {
        prop: 'extlinks',
        ellimit: 'max',
        titles: x.title
      }).then(function (z) {
        return z.query.pages[x.pageid].extlinks.map(function (A) {
          return A['*'];
        });
      });
    },
    links: function links() {
      var z = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : !0,
          A = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : 100,
          B = (0, _util.pagination)(d, {
        prop: 'links',
        plnamespace: 0,
        pllimit: A,
        titles: x.title
      }, function (C) {
        return C.query.pages[x.pageid].links.map(function (D) {
          return D.title;
        });
      });
      return z ? (0, _util.aggregatePagination)(B) : B;
    },
    categories: function categories() {
      var z = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : !0,
          A = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : 100,
          B = (0, _util.pagination)(d, {
        prop: 'categories',
        pllimit: A,
        titles: x.title
      }, function (C) {
        return C.query.pages[x.pageid].categories.map(function (D) {
          return D.title;
        });
      });
      return z ? (0, _util.aggregatePagination)(B) : B;
    },
    coordinates: function coordinates() {
      return (0, _util.api)(d, {
        prop: 'coordinates',
        titles: x.title
      }).then(function (z) {
        var A = z.query.pages[x.pageid];
        return A.coordinates ? A.coordinates[0] : s().then(function (B) {
          return (0, _coordinates.parseCoordinates)(B);
        });
      });
    },
    info: s,
    backlinks: function backlinks() {
      var z = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : !0,
          A = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : 100,
          B = (0, _util.pagination)(d, {
        list: 'backlinks',
        bllimit: A,
        bltitle: x.title
      }, function (C) {
        return C.query.backlinks.map(function (D) {
          return D.title;
        });
      });
      return z ? (0, _util.aggregatePagination)(B) : B;
    },
    rawImages: j,
    mainImage: function mainImage() {
      return Promise.all([j(), s()]).then(function (z) {
        var A = _slicedToArray(z, 2),
            B = A[0],
            C = A[1],
            D = getFileName(C.image || C.bildname || C.imagen || C.Immagine || C.badge || C.logo);

        if (!D) return q().then(function (F) {
          if (B.length) {
            B.sort(function (H, I) {
              return F.indexOf(I.title) - F.indexOf(H.title);
            });
            var G = B[0];
            return 0 < G.imageinfo.length ? G.imageinfo[0].url : void 0;
          }
        });
        var E = B.find(function (F) {
          var G = F.title,
              H = getFileName(G);
          return H === D || H.replace(/\s/g, '_') === D;
        });
        return E && 0 < E.imageinfo.length ? E.imageinfo[0].url : void 0;
      });
    },
    langlinks: function langlinks() {
      return (0, _util.api)(d, {
        prop: 'langlinks',
        lllimit: 'max',
        titles: x.title
      }).then(function (z) {
        return z.query.pages[x.pageid].langlinks.map(function (A) {
          return {
            lang: A.lang,
            title: A['*']
          };
        });
      });
    },
    rawInfo: q,
    fullInfo: function fullInfo() {
      return q().then(function (z) {
        return (0, _infoboxParser2.default)(z, d.parser);
      });
    },
    tables: function tables() {
      return (0, _util.api)(d, {
        prop: 'revisions',
        rvprop: 'content',
        titles: x.title
      }).then(function (z) {
        return get(z, 'query', 'pages', firstValue, 'revisions', 0, '*');
      }).then(function (z) {
        return (0, _infoboxParser2.default)(z, d.parser).tables;
      });
    },
    url: function url() {
      return x.canonicalurl;
    }
  };
}